const decryptText = async (encryptedText, inputFormat = 'base64', outputFormat = 'utf8') => {
    const ivByteSize = 12; // Initialization Vector (IV) size
    const saltByteSize = 16; // Salt size
    const authTagByteSize = 16; // Authentication tag size
    const keyLength = 16; // Key length in bytes
    const iterations = 65536; // PBKDF2 iteration count
    const digest = 'SHA-256'; // Hash for key derivation
    const algorithm = 'AES-GCM'; // Symmetric encryption algorithm

    const key = process.env.REACT_APP_KEY.split("&=")[1];
    // Fixed password for deriving the key
    try {
        // Decode encrypted text (base64 encoded)
        const bData = Uint8Array.from(atob(encryptedText), (c) => c.charCodeAt(0));

        // Extract IV, salt, auth tag, and ciphertext from the binary data
        const iv = bData.slice(0, ivByteSize);
        const salt = bData.slice(ivByteSize, ivByteSize + saltByteSize);
        const authTag = bData.slice(bData.length - authTagByteSize);
        const ciphertext = bData.slice(ivByteSize + saltByteSize, bData.length - authTagByteSize);

        const ciphertextWithTag = new Uint8Array(ciphertext.length + authTag.length);
        ciphertextWithTag.set(ciphertext, 0);
        ciphertextWithTag.set(authTag, ciphertext.length);
        // Derive the key using PBKDF2 with the fixed password
        const keyMaterial = await window.crypto.subtle.importKey(
            'raw',
            new TextEncoder().encode(key), // Encode the fixed password
            'PBKDF2',
            false,
            ['deriveBits', 'deriveKey']
        );

        const derivedKey = await window.crypto.subtle.deriveKey(
            {
                name: 'PBKDF2',
                hash: digest, // SHA-256 as the hash algorithm
                salt: salt.buffer, // Use the extracted salt
                iterations: iterations, // PBKDF2 iterations
            },
            keyMaterial,
            { name: 'AES-GCM', length: keyLength * 8 }, // Generate AES-GCM key (length converted to bits)
            false,
            ['decrypt'] // The key is used for decryption
        );

        // Decrypt the ciphertext using AES-GCM
        const decryptedBuffer = await window.crypto.subtle.decrypt(
            {
                name: algorithm,
                iv: iv.buffer, // Initialization vector
                tagLength: 128, // Authentication tag length
            },
            derivedKey,
            ciphertextWithTag.buffer
        );

        // Convert the decrypted data back to string
        return new TextDecoder(outputFormat).decode(decryptedBuffer);

    } catch (err) {
        // Log the error and throw
        console.error('Decryption Error:', err);
        throw new Error('Decryption failed');
    }
};

export default decryptText;